import { render } from "./CreateArrivalDeclarationStatusPage.vue?vue&type=template&id=c4faf47a"
import script from "./CreateArrivalDeclarationStatusPage.vue?vue&type=script&lang=js"
export * from "./CreateArrivalDeclarationStatusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__